import React, { useEffect, useState } from 'react';
import Search from './Search';
import Bell from '../assets/icons/svgicons/Bell.svg';
import User from '../assets/icons/svgicons/User.svg';
import { Link, useNavigate } from 'react-router-dom';
import { Notification } from './core/NotificationPopup/Active';
import { NotificationEmpty } from './core/NotificationPopup/Empty';
import { ReportBug } from './core/Help/ReportBug';
import { SidebarDrawer, Tab } from './common';
import questionMark from '../assets/icons/svgicons/questionMark.svg';
import { RequestFeature } from './core/Help/RequestFeature';
import ProcessSuccessful from '../assets/icons/ProcessSuccessful';
import { createSupport } from '../backend-services';
import { validateSupportForm } from '../modules/profile';
import { ICreateSupport } from '../@types';
import SuccessNotification from './core/Help/SuccessNotification';
import useNotifications from '../hooks/UseNotifications';
import { useStore } from '../state/useNotificationStore';
import LogoBlack from './LogoBlack';
import Menulogo from '../assets/icons/svgicons/menu.png';
import MobileSideMenu from './MobileSideMenu';
import { CloseIcon, LogoutIcon, SettingIcon } from '../assets/icons';
import CombineButton from './core/CombineButton/CombineButton';
import { Settings } from '../pages';

interface TopbarProps {
  onSidebarToggle: () => void;
}

const TopBar: React.FC<TopbarProps> = () => {
  const [showDrawer, setShowDrawer] = useState(false);
  const [showDraw, setShowDraw] = useState(false);
  const [showSideDrawer, setShowSideDrawer] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  const [isSubmitted, setIsSubmitted] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [triggerNotifications, setTriggerNotifications] = useState(true);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const batchUpdateNotifications = useStore((state) => state.batchUpdateNotifications);

  const navigate = useNavigate();

  const notifications = useStore((state) => state.notifications);
  const batchUpdate = useStore((state) => state.batchUpdateNotifications);

  const handleBellClick = () => {
    const updatedNotifcations = notifications?.map((notification) => ({ ...notification, isRead: true }));
    batchUpdate(updatedNotifcations);
    setShowDrawer(true);
  };
  // const handleBellClick = () => {
  //   if (notifications && notifications.length > 0) {
  //     const updatedNotifications = notifications.map((notification) => ({ ...notification, isRead: true }));
  //     batchUpdateNotifications(updatedNotifications);
  //     setShowDrawer(true);
  //   }
  // };
  
  const handleEmptyClick = () => {
    setShowDraw(true);
  };

  const handleHelpClick = () => {
    setShowSideDrawer(true);
  };

  const handleSubmit = async (supportData: ICreateSupport) => {
    setIsLoading(true);

    try {
      const validationErrors = validateSupportForm(supportData);
      const response = await createSupport(supportData);
      setIsSubmitted(true);
      setShowSuccessModal(true);
      setIsLoading(false);
    } catch (error) {
      console.error('Error creating support ticket:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useNotifications(triggerNotifications);

  const unreadNotificationsCount = useStore((state) => state.notifications?.length);
  useEffect(() => {
    return () => {
      setTriggerNotifications(false);
    };
  }, []);

  const handleShowMobileMenu = () => {
    setShowMobileMenu((prev) => !prev);
  };

 
  const dropdownItems = [
    { icon: <SettingIcon />, label: 'Profile' },
    { icon: <SettingIcon />, label: 'Settings' },
  ];

  return (
    <>
      {/* desktop navigation */}
      <div className="hidden lg:flex h-[66px] border items-center justify-between w-full px-[50px] sticky top-0 bg-[#F2F9FD] z-10">
        <Search />
        <div className="flex items-center">
          <p>Need any Help?</p>
          <Link to="#" className="text-[#044E97] font-semibold pr-[4px] pl-[10px] " onClick={handleHelpClick}>
            Help
          </Link>
          <img src={questionMark} alt="" className="pr-[30px]" onClick={handleHelpClick} />
          <div className="relative">
            <img
              src={Bell}
              alt=""
              className={`pr-[12px] cursor-pointer ${unreadNotificationsCount > 0 ? 'text-red-600' : ''}`}
              onClick={handleBellClick}
            />
            {unreadNotificationsCount > 0 && (
              <span className="absolute top-0 right-0 bg-red-600 text-white rounded-full w-6 h-6 text-center text-sm">
                {unreadNotificationsCount}
              </span>
            )}
          </div>
          {/* <img src={User} alt="" className="" /> */}
          {/* <CombineButton items={dropdownItems} businessName="Esemie" textColor="text-gray-500" size="medium" /> */}
        </div>
      </div>

      {/*  mobile navigation */}
      <div className="flex flex-row relative">
        <div className="absolute z-30">
          {showMobileMenu && <MobileSideMenu handleShowMobileMenu={handleShowMobileMenu} />}
        </div>
        <div className="h-[66px] flex lg:hidden border items-center justify-between w-full px-[50px] sticky top-0 bg-[#F2F9FD] z-10">
          <div className="flex flex-row  justify-between items-center gap-[35px] lg:gap-0  w-full">
            <div>
              <img src={Menulogo} className="cursor-pointer" onClick={handleShowMobileMenu} alt="" />
            </div>
            <div>
              <LogoBlack />
            </div>
            <div className="relative">
              <img
                src={Bell}
                alt=""
                className={`lg:pr-[12px] pr-[0px]  cursor-pointer ${
                  unreadNotificationsCount > 0 ? 'text-red-600' : ''
                }`}
                onClick={handleBellClick}
              />
              {unreadNotificationsCount > 0 && (
                <span className="absolute top-0 right-0 bg-red-600 text-white rounded-full w-6 h-6 text-center text-sm">
                  {unreadNotificationsCount}
                </span>
              )}
            </div>
            {/* <CombineButton items={dropdownItems} businessName="Esemie" textColor="text-gray-500" size="small" /> */}
          </div>
        </div>
      </div>

      <Notification show={showDrawer} onClose={() => setShowDrawer(false)} />
      <NotificationEmpty show={showDraw} onClose={() => setShowDraw(false)} />
      {showSideDrawer && (
        <>
          <div className="fixed top-0 left-0 right-0 bottom-0 z-50 bg-gray-500 bg-opacity-50"></div>
          <SidebarDrawer
            title="Report a Bug or Request a Feature "
            show={true}
            onClose={() => setShowSideDrawer(false)}
            position={'right'}
          >
            <div className="mt-[-2em]">
              <h1>
                Anything you are missing in our product? Kindly drop <br /> a message here to let us know!
              </h1>
              <p className="font-bold text-[16px] mt-[2em]">What would you like to do?</p>
              <Tab
                items={[
                  {
                    title: 'Report a Bug',
                    component: (
                      <ReportBug
                        onClose={() => setShowSideDrawer(false)}
                        showSideDrawer={showSideDrawer}
                        onSubmit={handleSubmit}
                      />
                    ),
                  },
                  {
                    title: 'Request a Feature',
                    component: (
                      <RequestFeature
                        showSideDrawer={showSideDrawer}
                        onClose={() => setShowSideDrawer(false)}
                        onSubmit={handleSubmit}
                      />
                    ),
                  },
                ]}
              />
            </div>
          </SidebarDrawer>
        </>
      )}
      {showSuccessModal && (
        <>
          <div className="fixed top-0 left-0 right-0 bottom-0 z-50 bg-gray-500 bg-opacity-50"></div>
          <SidebarDrawer title={''} onClose={() => setShowSuccessModal(false)} show={true} position={'right'}>
            <SuccessNotification
              showSuccessModal={false}
              icon={<ProcessSuccessful />}
              onClose={() => setShowSuccessModal(false)}
            />
          </SidebarDrawer>
        </>
      )}
    </>
  );
};

export default TopBar;
